import SettingsDropdown from './SettingsDropdown';

export default SettingsDropdown;
